import { Fragment } from 'react'

import { Skeleton } from '@/components/ui'
import { cn } from '@/utils'
import { FACTS_GRID } from './mapLayout'

// Account, dates, status, pages and file, each about as wide as its real value tends to be.
const FACT_WIDTHS = ['w-36', 'w-40', 'w-24', 'w-20', 'w-44']

// Stands in for the open statement's facts, on the real rows, so nothing jumps when they land.
export const LoadingStatementBar = () => (
  <div
    data-loading-statement
    className={cn(FACTS_GRID, 'items-center gap-y-3')}
  >
    {FACT_WIDTHS.map((width) => (
      <Fragment key={width}>
        <Skeleton className="h-2.5 w-10" />
        <Skeleton className={cn('h-4', width)} />
      </Fragment>
    ))}
  </div>
)
